import { getProfileImageUrl } from '../../common/helpers/helpers';

export type SidebarProfileNameFields = {
  firstName?: string | null;
  lastName?: string | null;
  channelName?: string | null;
};

export type SidebarAvatarView =
  | { kind: 'photo'; src: string; initials: string }
  | { kind: 'initials'; initials: string };

/** First+last initials, else channel initial — uppercase, never empty marker. */
export function getProfileInitials(user: SidebarProfileNameFields): string {
  const fromName = `${user.firstName?.charAt(0) || ''}${
    user.lastName?.charAt(0) || ''
  }`;
  const initials = (fromName || user.channelName?.charAt(0) || '').toUpperCase();
  return initials;
}

/**
 * Sidebar avatar presentation. A non-empty profile URL is attempted as a photo
 * until the image reports load failure — then initials (never a broken img).
 */
export function resolveSidebarAvatarView(input: {
  profileImageURL?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  channelName?: string | null;
  photoLoadFailed?: boolean;
}): SidebarAvatarView {
  const initials = getProfileInitials(input);
  const src = getProfileImageUrl(input.profileImageURL || '');
  if (src && !input.photoLoadFailed) {
    return { kind: 'photo', src, initials };
  }
  return { kind: 'initials', initials };
}
